module.exports = __webpack_public_path__ + "static/ouroboros-game-landing-page-background-f04d7d36a941b678103a772fc50571c4.jpg";